import {useState, useEffect} from 'react'
import Article from "./article"

import AddArticle from './addArticle';

import {supabase} from "./supabaseClient"

export default function ArticleList() {

  const [modal_open, set_modal_open] = useState(false);

  const [articles, set_articles] = useState<any>([])

  useEffect(() => {
    getArticles()

  }, [])

  const getArticles = async () => {
    console.log("Get articles")
    let { data, error }:any = await supabase.from('article').select('*')
    console.log(data)
    console.log(error)

    set_articles(data)
  }


  const openModal = ()=>{
    set_modal_open(true);
  }
  const closeModal = () => {
    set_modal_open(false)
  }

  return (
    <div className="bg-white py-6 sm:py-8 lg:py-12">
      <div className="mx-auto max-w-screen-xl px-4 md:px-8">
        <div className="mb-10 md:mb-16">
          <h2 className="mb-4 text-center text-2xl font-bold text-gray-800 md:mb-6 lg:text-3xl">記事一覧</h2>

          <p className="mx-auto max-w-screen-md text-center text-gray-500 md:text-lg">
            現在投稿されている記事の一覧です。編集や削除等の操作が行えます。
          </p>
          <button type="button" onClick={openModal} className="px-8 py-3 font-semibold rounded-full dark:bg-blue-100 dark:text-blue-800">新規投稿</button>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-2 xl:grid-cols-2 xl:gap-8">

          {
            articles.map( (article:any) => {
              return (
                <Article
                  key={article.id}
                  article={article}
                ></Article>
              )
            })
          }

        </div>
      </div>
      <AddArticle
        modal_open={modal_open}
        closeModal={closeModal}
      ></AddArticle>
    </div>
  )

}